var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { DrawerHeader } from "syf-component-library/ui/atoms";
import { Body } from "syf-component-library/ui/typography";
import getAccountTitle from "./helpers";
import { useAccountSummary } from "../../../const/syfApiQueries";
import { useProfileGlobalState } from "../../../context/profileGlobalState";
import { useConfig } from "../../../hooks/useConfig";
import useCurrentAccount from "../../../hooks/useCurrentAccounts";
import getTranslation from "../../../strings/getTranslations";
var CardHeader = function () {
    var _a;
    var t = getTranslation().t;
    var profileConfig = useConfig();
    var assets = profileConfig.hosts.assets;
    var selectedAccountId = useProfileGlobalState().state.selectedAccountId;
    var accounts = useCurrentAccount(selectedAccountId);
    var selectedAccountOption = accounts.selectedAccountOption;
    var selectedAccountSummary = useAccountSummary(selectedAccountOption.value, profileConfig).data;
    return (_jsx(DrawerHeader, { img: (_a = selectedAccountSummary === null || selectedAccountSummary === void 0 ? void 0 : selectedAccountSummary.card.cardArtURL) !== null && _a !== void 0 ? _a : "".concat(assets, "/assets/cardArt/syf_generic_card.svg"), fallbackImage: "".concat(profileConfig.hosts.assets.origin, "/assets/cardArt/syf_generic_card.svg"), subtitle: _jsx(Body, __assign({ weight: "semiBold" }, { children: t(getAccountTitle(selectedAccountSummary === null || selectedAccountSummary === void 0 ? void 0 : selectedAccountSummary.product.type)).concat(" ", selectedAccountOption === null || selectedAccountOption === void 0 ? void 0 : selectedAccountOption.label.slice(-4)) })), title: selectedAccountOption === null || selectedAccountOption === void 0 ? void 0 : selectedAccountOption.label.slice(0, -7), alt: "image" }));
};
export default CardHeader;
